module.exports = __webpack_public_path__ + "static/concept2-sp-826841c00f6c57f58e1707b54c21f1f6.svg";